namespace TabAurous.Purchase {
    export interface OrderRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        VoucherTypeName?: string;
        PartyId?: number;
        LedgerName?: string;
        PartyCode?: string;
        GstVat?: string;
        Pan?: string;
        Address1?: string;
        Country?: string;
        State?: string;
        City?: string;
        TermsId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        NetAmount?: number;
        TaxAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        GrossAmount?: number;
        Remark?: string;
        CompanyId?: number;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        FinancialYearId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        UserId?: number;
        ItemDetails?: OrderItemsRow[];
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        ProductItemImage?: string;
        CCNetAmount?: number;
        CCGrossAmount?: number;
        Username?: string;
    }

    export namespace OrderRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Purchase.Order';
        export const deletePermission = 'Purchase:Purchase Order:Delete';
        export const insertPermission = 'Purchase:Purchase Order:Add';
        export const readPermission = '*';
        export const updatePermission = 'Purchase:Purchase Order:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            VoucherTypeName = "VoucherTypeName",
            PartyId = "PartyId",
            LedgerName = "LedgerName",
            PartyCode = "PartyCode",
            GstVat = "GstVat",
            Pan = "Pan",
            Address1 = "Address1",
            Country = "Country",
            State = "State",
            City = "City",
            TermsId = "TermsId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            NetAmount = "NetAmount",
            TaxAmount = "TaxAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            GrossAmount = "GrossAmount",
            Remark = "Remark",
            CompanyId = "CompanyId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            FinancialYearId = "FinancialYearId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            UserId = "UserId",
            ItemDetails = "ItemDetails",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            ProductItemImage = "ProductItemImage",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount",
            Username = "Username"
        }
    }
}
